type Listener = () => void;

const listeners: Listener[] = [];

export const emitPlanBlocked = () => {
  listeners.forEach((fn) => fn());
};

export const onPlanBlocked = (callback: Listener): (() => void) => {
  listeners.push(callback);
  return () => {
    const idx = listeners.indexOf(callback);
    if (idx > -1) listeners.splice(idx, 1);
  };
};
